import React from 'react';
import { observer } from 'mobx-react';
import { CircularProgress } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
    ThemedButton,
    FlexDiv,
    SpaceBetweenDiv,
    CheckboxInput,
} from '@awarego-ui/components';
import TableClient from '../../../components/table/TableClient';

function BouncedEmailsTable({ companyId, productId, store }) {
    const {
        columns,
        usersList,
        isDownloading,
        loadingUsersList,
        showObsolete,
        bouncedObsoleteCount,
    } = store;

    // The server already returns the filtered set (selected lists + obsolete
    // toggle); the client only paginates it. While (re)loading, pass empty data
    // so TableClient shows its full spinner instead of stale rows.
    const data = loadingUsersList ? [] : usersList.slice();

    const handleDownloadCSV = () => {
        store.downloadCSV(companyId, productId);
    };

    return (
        <FlexDiv column>
            <SpaceBetweenDiv my={10} alignCenter>
                {bouncedObsoleteCount > 0 || showObsolete ? (
                    <CheckboxInput
                        label={`Show obsolete (${bouncedObsoleteCount})`}
                        checked={showObsolete}
                        onChange={() => store.setShowObsolete(!showObsolete)}
                    />
                ) : (
                    <span />
                )}
                <ThemedButton
                    mode="secondary"
                    size="tiny"
                    $noTextTransform
                    onClick={handleDownloadCSV}
                    disabled={loadingUsersList || usersList.length === 0}
                    text={
                        <>
                            {isDownloading && <CircularProgress size={10} />}{' '}
                            Download .csv
                            <GetAppIcon fontSize="small" />
                        </>
                    }
                />
            </SpaceBetweenDiv>
            <TableClient
                columns={columns}
                data={data}
                defaultSortBy={'name'}
                defaultSortDescent={false}
                loadingData={loadingUsersList}
            />
        </FlexDiv>
    );
}

export default observer(BouncedEmailsTable);
